import { useRef, useState, forwardRef, Ref, useImperativeHandle, useEffect } from 'react';
import type { ReactNode } from 'react';
import cx from 'classnames';
import useClickAway from '@/hooks/useClickAway'; 
import Styles from './index.module.scss';

export declare type Action = {
  text: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  key?: string | number;
  onClick?: () => void;
};
interface menuItem {
  key: string;
  text: string;
  onAction?: (item: Action) => void;
}

export type IPopoverRef = { 
  getPopoverVisilble: () => boolean,
  hidePopover: (vis: boolean | undefined) => void;
};

interface IPopover {
  className?: string;
  children: React.ReactElement;
  popoverNode: React.ReactElement;
  callback?: (visible: boolean)=>void;
}

export const PopoverCommonModal = ({
  children,
  className,
}: { children: React.ReactElement, className?: string }) => {
  return (
    <div className={cx(Styles.modalRoot, className)}>
      { children }
    </div>
  )
}

const Popover = ({className, children, popoverNode, callback}: IPopover, ref: Ref<IPopoverRef>) => {
  const [visible, setVisible] = useState(false);
  const targetRef = useRef<HTMLDivElement | null>(null);

  useClickAway(targetRef, () => setVisible(false));

  useImperativeHandle(ref, () => ({
    getPopoverVisilble: () => !visible,
    hidePopover,
  }));

  const hidePopover = (vis=false) => {setVisible(vis)}

  useEffect(() => {
    callback?.(visible);
  }, [visible]) 

  return (
    <div className={cx(Styles.root, className)} ref={targetRef}>
      <div onClick={()=>setVisible(v => !v)}>{ children }</div>
      { visible && popoverNode }
    </div>
  );
}
export default forwardRef(Popover);